import * as Sentry from "@sentry/nextjs";

export function identifyUser(id: string | null | undefined): void {
  try {
    Sentry.setUser(id ? { id, ip_address: "{{auto}}" } : null);
  } catch {
    return;
  }
}
